// extracted by mini-css-extract-plugin
module.exports = {"hidden":"applyStatus_hidden__BuSZO","textEmphasis":"applyStatus_textEmphasis__pz06h","wrap":"applyStatus_wrap__MGZmy"};